import React, { FC } from 'react';
import styled from 'styled-components';

const StyledButton = styled.button`
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--spacer-XS);
    background-color: white;
    border: var(--border-thin) solid var(--appLigthGrey);
    border-radius: 0.5rem;
    font-size: 1rem;
    font-weight: 500;
    color: var(--text-body);
    cursor: pointer;
    transition: background-color 0.2s;
    margin-bottom: var(--spacer-S);

    &:hover {
        background-color: var(--bg-hover-light);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

const AppleIcon = styled.svg`
    width: 1.5rem;
    height: 1.5rem;
`;

interface AppleSignInButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

export const AppleSignInButton: FC<AppleSignInButtonProps> = ({ onClick, disabled }) => {
    return (
        <StyledButton onClick={onClick} disabled={disabled} type="button">
            <AppleIcon viewBox="0 0 24 24">
                <path fill="#000000" d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
            </AppleIcon>
            Continue with Apple
        </StyledButton>
    );
};
